import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import {
  AiOutlineSearch,
  AiOutlineShoppingCart,
  AiOutlineUser,
} from "react-icons/ai";

export default function Mobile() {
  let [menuBar, setMenuBar] = useState("collapse");
  const toggleMenu = () => {
    setMenuBar(menuBar === "collapse show" ? "collapse" : menuBar);
  };
  return (
    <>
      <Nav
        className="navbar navbar-expand-lg navbar-light shadow d-lg-none"
        style={{
          backgroundColor: "var(--navbar)",
          position: "sticky",
          top: 0,
          zIndex: 3,
        }}>
        <div className="container d-flex justify-content-between align-items-center" >
          <Link
            className="logo align-self-center text-decoration-none"
            to="/"
            style={{ width: "auto" }}>
            <div
              className="logo-badge"
              style={{
                padding: "4px 12px",
                borderRadius: "8px",
              }}>
              <img
                src={Logo}
                alt="VEBBOX Software Solutions logo"
                style={{
                  maxWidth: "180px",
                  maxHeight: "42px",
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          </Link>

          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={() => {
              toggleMenu();
            }}
            data-bs-toggle={menuBar}
            data-bs-target="#templatemo_main_nav"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between"
            id="templatemo_main_nav">
            <div className="flex-fill">
              <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/"
                    onClick={() => toggleMenu()}>
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/herbalProduct">
                    Category 1
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/yoga">
                    Category 2
                  </Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/gardenProduct">
                    Garden Products
                  </Link>
                </li> */}
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/yogaProduct">
                    Yoga Products
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/spices">
                    Spices
                  </Link>
                </li> */}
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/foodProduct">
                    Food Products
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/about">
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/gallery">
                    Gallery
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/tracker">
                    Tracker
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/uniqueProducts">
                    Unique Products
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/cart/:productId"
                    className="nav-icon position-relative text-decoration-none">
                    <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
                    {/* <label className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-danger text-light">
                      4
                    </label> */}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/profile/:productId"
                    className="nav-icon position-relative text-decoration-none">
                    <AiOutlineUser style={{ fontSize: "1.7em" }} />
                  </Link>
                </li>
              </ul>
            </div>
           
          </div>
        </div>
      </Nav>
    </>
  );
}
